import { render } from "./LifeOnFire.vue?vue&type=template&id=77b9b1fc&scoped=true"
import script from "./LifeOnFire.vue?vue&type=script&lang=js"
export * from "./LifeOnFire.vue?vue&type=script&lang=js"

import "./LifeOnFire.vue?vue&type=style&index=0&id=77b9b1fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b9b1fc"]])

export default __exports__